import React from 'react';
import { FooterSection } from './style' ;


const Footer = () => {
    return (
        <FooterSection>
            <p> copyright &copy; 2020 by Yehia Bassam </p>
        </FooterSection>
    );
}

export default Footer;
